import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface CompanionFormState {
  voiceId: string | null;
}

const initialState: CompanionFormState = {
  voiceId: null,
};

export const companionFormSlice = createSlice({
  name: "companionForm",
  initialState,
  reducers: {
    setVoiceId: (state, action: PayloadAction<string | null>) => {
      state.voiceId = action.payload;
    },
  },
});

export const { setVoiceId } = companionFormSlice.actions;

export default companionFormSlice.reducer;
